import { within } from './selection'

export function byRegion(type) {
  return state => {
    let records = state[type]
    let region = state.ui.region.value

    return records.filter(r => r.Region === region)
  }
}

function shouldHighlight(item, query) {
  if (query.selected) {
    return within(query.selected, item.Key)
  } else if (query.category) {
    return within(query.category, item.Category)
  }

  return true
}

function shouldFocus(item, query, state) {
  if (state.ui && state.ui.focused) {
    return state.ui.focused === item.Key
  }

  return within(query.selected, item.Key)
}

export function highlight(query) {
  return (aggregate, state) => {
    return aggregate.map(item => {
      const isActive = shouldHighlight(item, query)
      const isFocused = shouldFocus(item, query, state)

      if (isActive || isFocused) {
        return { ...item, isActive, isFocused }
      }

      return item
    })
  }
}

export function focusedAggregate(aggregate) {
  return aggregate.filter(item => item.isFocused)
}

export function activeAggregate(query) {
  let selector = item => within(query.selected, item.Key)

  return records => records.find(selector)
}

export function currentAggregates(query) {
  let selector = item => within(query.selected, item.Key)

  return records => records.filter(selector)
}



// WEBPACK FOOTER //
// ./src/queries.js